// Utilities for displaying and adding questions.
import { Pad } from "component/basics"
import { CTAButton } from "component/button"
import { TextField } from "component/text"
import { useDatastore, useModuleMap, useModuleObject } from "util/datastore"
import { useState } from "react";
import { View } from "react-native";
import { undefA, t } from "util/stdtypes";
import { useConfig } from "util/features";
import { defineModuleMap } from "util/moduledata";

export type QuestionAdderConfig = {
    questionAdderWidgets?: any[]
}

export function AddQuestionBox({onAdded = undefA, onChange = undefA}) {
    const [question, setQuestion] = useState('');
    const [inProgress, setInProgress] = useState(false);
    const datastore = useDatastore();
    const {questionAdderWidgets} = useConfig<QuestionAdderConfig>()
    
    async function onAdd() {
        setInProgress(true);
        const result = await datastore.callServerAsync('questions', 'add', {newInstance: {name: question}});
        onAdded && onAdded(result.questionKey);
        setInProgress(false);
        setQuestion('');
        onChange && onChange('');
    }

    return <View>
        <TextField autoFocus value={question} onChange={text => {setQuestion(text); onChange && onChange(text)}}
            multiline={false}
            testID='add-question' label={t('Ask a question')} placeholder={t('Ask a question...')} />
        {(question || inProgress) && <Pad />}
        {inProgress ? 
            <CTAButton disabled label={t('Adding...')} />
            : question ?
                <CTAButton label={t('Add Question')} onPress={onAdd} />
                : null
        }
        <Pad size={8}/>
        {questionAdderWidgets && questionAdderWidgets.map((Widget,i)=><Widget key={i} instanceKey={question} structureKey={"question"} />)}
    </View>
}

export type Question = {
    question: string,
    from: string,
    time: number,
    commentCount?: number,
}

const moduleMapQuestion = defineModuleMap<Question>("PUBLIC", 'question', null);

export function useGlobalQuestions() {
    const questionObjs = useModuleMap(moduleMapQuestion);
    if (!questionObjs) {
        return [];
    }
    const keys = Object.keys(questionObjs);
    const questions = keys.map(key => ({key, ...questionObjs[key]}));
    return questions;
}

export function useQuestion(key: string) {
    const question = useModuleObject(moduleMapQuestion, key);
    return question;
}
